// src/layouts/MainLayout.tsx
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import config from "@/config/env";

export const MainLayout: React.FC = () => {
  const location = useLocation();

  // Don't show header/footer on success/failure pages
  const isPaymentPage =
    location.pathname.includes("/booking/success") || location.pathname.includes("/booking/failed");

  if (isPaymentPage) {
    return <Outlet />;
  }

  // Hide QLT branding for hotel-branded sites (SLS, Rosewood)
  const isHotelBranded = config.hotel === "sls" || config.hotel === "rosewood";

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-3 md:py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center">
            {!isHotelBranded && (
              <h1 className="text-xl md:text-3xl font-bold text-gray-900">QLT Booking</h1>
            )}
            <div className={isHotelBranded ? "ml-auto" : ""}>
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-4 md:py-8 flex-grow">
        <Outlet />
      </main>

      {!isHotelBranded && (
        <footer className="bg-gray-800 text-white">
          <div className="max-w-7xl mx-auto py-3 md:py-6 px-4 sm:px-6 lg:px-8">
            <p className="text-center text-sm md:text-base">
              © {new Date().getFullYear()} Quik Luxury Transportation Ltd. All rights reserved.
            </p>
          </div>
        </footer>
      )}
    </div>
  );
};

export default MainLayout;
